/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules/index';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

const initialState = {
  menuOpened: false,
  fileViewerOpened: false,
  currentOverlayFile: null,
  alertMessage: null,
  banner: {
    display: true,
    message: null,
    button: {
      title: null,
      to: null,
    },
  },
};
export default new Vuex.Store({
  state: initialState,
  mutations,
  actions,
  modules,
});
